<template>
    <div style="display: flex; flex-direction: column; align-items: center">
        <div style="margin: 28px">
            <span style="font-size: 22px">结果公示</span>
        </div>
        <el-form :model="vo" @submit.native.prevent>
            <div style="width: 100%" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody v-for="item in dataList" :key="item">
                            <tr>
                                <td ref="tdlbl_所属项目" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'tbXmmc'" class="field">所属项目</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="tbXmmc"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 1,
                                            elementType: 'input',
                                            emptyMessage: '请输入所属项目',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '所属项目',
                                            propName: 'tbXmmc',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: 1000,
                                            valueMinLength: null,
                                            model: 'vo.tbXmmc',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 1,
                                            showWordLimit: false,
                                            dialogType: 'listpage',
                                            dialogOrgLevel: '',
                                            dialogSelectedOrderBy: 'orgOrderNo',
                                            dialogMultiple: false,
                                            dialogOrgSelf: false,
                                            dialogOnlyCurSys: true,
                                            dialogTitle: '选择所属项目',
                                            dialogListviewurl: 'tbgl.tbxmlx.listAllFile?urlsearch=status:2',
                                            dialogExcludeFileds: 'flCreator,flCreateDept,flCreateDate,wfNodeNames'
                                        }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目编号" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'tbXmbh'" class="field">项目编号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="tbXmbh"
                                        :field="{ defaultValue: null, elementCanEdit: '0', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入项目编号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '项目编号', propName: 'tbXmbh', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.tbXmbh', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_项目类型" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'tbType'" class="field">项目类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="tbType"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '0',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：招标代理\n2：造价咨询\n3：其它',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择项目类型',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '项目类型',
                                            propName: 'tbType',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.tbType',
                                            option: [
                                                { value: '1', name: '招标代理' },
                                                { value: '2', name: '造价咨询' },
                                                { value: '3', name: '其它' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_招标方式" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'zbWay'" class="field">招标方式</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="zbWay"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：公开招标\n2：非公开招标',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择招标方式',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '招标方式',
                                            propName: 'zbWay',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.zbWay',
                                            option: [
                                                { value: '1', name: '公开招标' },
                                                { value: '2', name: '非公开招标' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_开标日期 " class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'kbDate'" class="field">开标日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="kbDate"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: 'format：yyyy年MM月dd日\r\n', elementReadonly: 1, elementType: 'date', emptyMessage: '请输入开标日期 ', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '开标日期 ', propName: 'kbDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日\r\n', valueMaxLength: null, valueMinLength: null, model: 'vo.kbDate', option: [], weekday: 0 }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_开标地点" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'kbAddress'" class="field">开标地点</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="kbAddress"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入开标地点', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '开标地点', propName: 'kbAddress', propType: 'String', textFormatter: 'textfield', valueMaxLength: 100, valueMinLength: null, model: 'vo.kbAddress', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_出席人" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'kbPeoples'" class="field">出席人</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="kbPeoples"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 1,
                                            elementType: 'input',
                                            emptyMessage: '请输入出席人',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '出席人',
                                            propName: 'kbPeoples',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: 100,
                                            valueMinLength: null,
                                            model: 'vo.kbPeoples',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 1,
                                            showWordLimit: false,
                                            dialogType: 'staff',
                                            dialogOrgLevel: '',
                                            dialogSelectedOrderBy: 'orgOrderNo',
                                            dialogMultiple: false,
                                            dialogOrgSelf: false,
                                            dialogOnlyCurSys: true
                                        }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_结果登记情况" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'kbResult'" class="field">结果登记情况</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="kbResult"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：中标\n2：未中标\n3：流标\n4：废标',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择结果登记情况',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '结果登记情况',
                                            propName: 'kbResult',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.kbResult',
                                            option: [
                                                { value: '1', name: '中标' },
                                                { value: '2', name: '未中标' },
                                                { value: '3', name: '流标' },
                                                { value: '4', name: '废标' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_结果公示地址" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'kbRstHref'" class="field">结果公示地址</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="kbRstHref"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入结果公示地址', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '结果公示地址', propName: 'kbRstHref', propType: 'String', textFormatter: 'textfield', valueMaxLength: 1000, valueMinLength: null, model: 'vo.kbRstHref', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_备注" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'flContent'" class="field">备注</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="flContent"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: 70,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'textarea',
                                            emptyMessage: '请输入备注',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 0,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '备注',
                                            propName: 'flContent',
                                            propType: 'String',
                                            textFormatter: 'textarea',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.flContent',
                                            option: [],
                                            autosize: true
                                        }"
                                        :vo="item"
                                        :can-edit="canEdit"
                                        :autosize="true"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    components: {},
    filters: {
        setTimeData(val) {
            if (val) return moment(val).format('YYYY-MM-DD HH:mm')
            return ''
        }
    },
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 0 },
        module: { type: String, default: null }
    },
    data() {
        return {
            dataList: []
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {
        this.getdata()
    },
    methods: {
        getdata() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { id: this.vo.id },
                url: 'tbgl/tbxmArch/getJgdjById'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        this.dataList = response.body.listdata
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';
/deep/.el-form .el-table.el-table--border td {
    text-align: left;
}
</style>
